import { useContext } from 'react';
import { useGetOperators } from './useGetOperators';
import { Map as ImmutableMap } from 'immutable';
import { __ANY_CTA } from 'customer-data-filters-ui/converters/listSegClassic/ListSegConstants';
import { CTA } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import Equal from 'customer-data-filters-ui/filterQueryFormat/operator/Equal';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
import { EVENT_BASED_FIELD_KEYS, getBaseEventBasedFilterFamilyField, getEventBasedFilterFamilyFields, getRefinementCondition } from '../strategy/eventBasedFilters';
export const useCTAFilter = (condition, onChange) => {
  const {
    data
  } = useContext(SegmentationFiltersInstanceContext);
  const ctaFields = getEventBasedFilterFamilyFields(CTA, data, condition);
  const {
    getRefinementOperators
  } = useGetOperators();
  const statusCondition = condition.set('field', getBaseEventBasedFilterFamilyField(CTA));
  const subjectVersionField = ctaFields.get(EVENT_BASED_FIELD_KEYS.EVENT_SUBJECT_VERSION);
  const subjectVersionCondition = Equal.of(subjectVersionField).set('value', condition.value || __ANY_CTA);
  const dateRefinementCondition = getRefinementCondition(CTA, condition.dateRefinement);
  const numberRefinementCondition = getRefinementCondition(CTA, condition.numberRefinement);
  const onSubjectVersionValueChange = ctaSubjectVersionCondition => {
    const ctaSubjectVersionName = ctaSubjectVersionCondition.value;
    const newCondition = condition.set('value', ctaSubjectVersionName);
    onChange(newCondition);
  };
  const getRefinementsWithEmptyValue = refinementFields => {
    return refinementFields.map(field => {
      const operators = getRefinementOperators(CTA, field);
      return operators.first().of(field);
    });
  };
  const refinementFields = getEventBasedFilterFamilyFields(CTA, ImmutableMap(), condition, true);
  const refinementConditionsEmptyValue = getRefinementsWithEmptyValue(refinementFields.toArray());
  return {
    statusCondition,
    subjectVersionCondition,
    dateRefinementCondition,
    numberRefinementCondition,
    refinementConditionsEmptyValue,
    onSubjectVersionValueChange
  };
};